/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDiaglabSample } from 'app/shared/model/diaglab-sample.model';
import { IUserLabTestItem } from 'app/shared/model/user-lab-test-item.model';
import { IDiaglabAssistant } from 'app/shared/model/diaglab-assistant.model';
import { SampleStatus } from 'app/shared/model/enumerations/sample-status.model';
import { TypeOfSample } from 'app/shared/model/enumerations/type-of-sample.model';
import { UOM } from 'app/shared/model/enumerations/uom.model';

export interface IDiaglabSampleItem {
  id?: string;
  itemAccessionNo?: string;
  referredToOrFrom?: string | null;
  quantity?: number;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  status?: keyof typeof SampleStatus | null;
  typeOfSample?: keyof typeof TypeOfSample | null;
  testSquence?: number;
  rejectReason?: string | null;
  uom?: keyof typeof UOM | null;
  collectionDate?: number | null;
  enteredDate?: number | null;
  sendingdDate?: number | null;
  receivedDate?: number | null;
  acceptingDate?: number | null;
  precessingDate?: number | null;
  completionDate?: number | null;
  verificationDate?: number | null;
  authenticationDate?: number | null;
  releasedDate?: number | null;
  transmissionDate?: number | null;
  sample?: IDiaglabSample | null;
  labTestItem?: IUserLabTestItem;
  collector?: IDiaglabAssistant | null;
}

export const defaultValue: Readonly<IDiaglabSampleItem> = {
  active: false,
};
